<template>
    <div class="radiofield">
        <div class="label">
            <span>{{ radioLabel }}</span>
        </div>
        <template v-for="option of radioOptions" :key="option">
            <div class="radio">
                <label :for="option.name">
                    <input
                        :id="option.name"
                        type="radio"
                        :name="name(radioName)"
                        :value="option.value"
                        @change="radioChange($event.target.value, name(radioName))"
                        :checked="option.default"
                    /><span>{{ option.label }}</span></label
                >
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'RadioField',
    props: {
        radioLabel: String,
        radioOptions: Array,
        radioName: String,
        radioCallback: Function,
    },
    data() {
        return {
            randomName: null,
        }
    },
    mounted() {
        this.randomName = (Math.random() + 1).toString(36).substring(7)
    },
    methods: {
        name(value) {
            if (value) {
                return value
            } else {
                return this.randomName
            }
        },
        radioChange(value, id) {
            this.radioCallback(value, id)
        },
    },
}
</script>

<style scoped></style>
